import { render, staticRenderFns } from "./AdminData.vue?vue&type=template&id=3ed4b52d&"
import script from "./AdminData.vue?vue&type=script&lang=ts&"
export * from "./AdminData.vue?vue&type=script&lang=ts&"
import style0 from "./AdminData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports